import React, { useState } from "react";

import RemoveIcon from "../../icons/remove-icon";
import UploadIcon from "../../icons/upload-icon";

import lb from "../../data/Labels.json";

const InputFile = ({ name }) => {
  const [hasFile, toggleFile] = useState({ file: false, name: "" });

  return (
    <label htmlFor={name} className="file-input-wrapper">
      <div className="wrapper">
        <input
          onChange={(e) => {
            toggleFile({
              file: e.target.files.length,
              name: e.target.files.item(0).name,
            });
          }}
          type="file"
          id={name}
          name={name}
        />
        <React.Fragment>
          <i>{hasFile?.file ? <RemoveIcon /> : <UploadIcon />}</i>
          <p>{hasFile?.name ? hasFile.name : lb.Upload}</p>
        </React.Fragment>
      </div>
    </label>
  );
};

export default InputFile;
